<template>
  <div class="wrapper" @click="clickOutside">
    <section class="search-panel">
      <div class="gutter row">
        <label class="ym-label">Tracking Link</label>
        <e-input class="select" v-model="params.url"></e-input>
      </div>
      <div class="gutter row">
        <div class="col pr">
          <label class="ym-label">Country</label>
          <e-select
            class="select"
            ref="country"
            @selectDataChange="selectCountry"
            :selectlist="country"
            val="code"
            label="code_name"
            advancedSearch="code"
            :defaultVal="params.country"
          ></e-select>
        </div>

        <div class="col pl">
          <label class="ym-label">System</label>
          <e-select
            class="select"
            ref="os"
            @selectDataChange="selectOS"
            :selectlist="os"
            val="id"
            label="name"
            :defaultVal="params.os"
          ></e-select>
        </div>
      </div>

      <div class="gutter row">
        <div class="col pr">
          <label class="ym-label">Connection Type</label>
          <e-select
            class="select"
            ref="zone"
            @selectDataChange="selectZone"
            :selectlist="zone"
            val="id"
            label="name"
            :defaultVal="params.zone"
          ></e-select>
        </div>

        <div class="col pl">
          <label class="ym-label">Carrier</label>
          <e-select
            class="select"
            ref="carrier"
            @selectDataChange="selectCarrier"
            :selectlist="carrier"
            :disabled="this.params.zone !== '2'"
            val="code"
            label="carrier"
            :defaultVal="params.carrier"
            :placeholder="this.params.zone !== '2' ? 'Carrier is valid only with Mobile.' : ''"
          ></e-select>
        </div>
      </div>

      <div>
        <button class="submit-width submit" @click="search" @keyup.enter="search">GO</button>
        <p v-if="$parent.isOFFERSYOUMI || $parent.isYOUMIEN" class="ym-label info-rest">
          You have
          <em>{{ check_times }}</em>
          free test(s) left today.
        </p>
      </div>
    </section>

    <loading v-if="LOADING"></loading>

    <section class="result-panel" v-if="result.length || error">
      <hr class="hr" v-if="!$parent.isYOUMIEN" />

      <div class="result">
        <h3 class="result-title">RESULT</h3>

        <div class="result-list">
          <div class="center error" v-if="error">
            <e-icon class="pointer" icon="i-excalmatory-fill"></e-icon>
            <span class="error_tip">{{ error_message }}</span>
          </div>

          <div v-for="(res, index) in result" :key="index">
            <div class="list-item row">
              <div class="item-left" :class="{ 'item-left-short': false }">
                <span class="ms green" v-if="index !== result.length - 1">{{ res.delta }}ms</span>
                <span class="ms" :class="{red:!land_page, green:land_page}" v-else>{{ delta }}ms</span>
                <span
                  v-if="!land_page && index === result.length - 1"
                  class="circle background-red inline-block"
                >
                  <e-icon icon="yicon-wrong"></e-icon>
                </span>
                <span
                  v-else
                  class="circle background-green inline-block"
                  :class="{ 'has-dashed-line': index !== result.length - 1 }"
                >
                  <e-icon icon="yicon-down2"></e-icon>
                </span>
                <span v-if="$parent.isOFFERSYOUMI || $parent.isYOUMIEN" class="item-index">
                  {{ index + 1 }}
                </span>
                <button v-else class="status" @click="showDetail(res)">
                  {{ res.status }}
                </button>
              </div>
              <div class="item-center">
                <e-input v-model="res.url" disabled class="res-url"></e-input>
              </div>
              <div class="item-right">
                <e-icon
                  class="pointer"
                  icon="yicon-view"
                  @click.native="localview(res.url)"
                ></e-icon>
              </div>
            </div>
          </div>
        </div>

        <div class="result-footer" v-if="result.length">
          <button class="submit-width submit" @click="screenshot">
            Screenshot
          </button>
          <div class="footer-copy">
            <e-icon v-if="hideSuccess" class="gradient-icon" icon="yicon-copy"></e-icon>
            <e-icon v-else class="gradient-icon" icon="yicon-down2"></e-icon>
            <span
              v-if="hideSuccess"
              class="ym-label pointer"
              v-clipboard:copy="location()"
              v-clipboard:success="copySuccess"
            >
              COPY PAGE LINK
            </span>
            <span v-else class="ym-label">
              Successfully Copied
            </span>
          </div>
        </div>
      </div>
    </section>

    <e-dialog ref="detailDialog"></e-dialog>
  </div>
</template>

<script>
import Http from './js/common/http.js'
import setting from './js/common/setting.js'
import loading from '../components/loading.vue'
import ESelect from '../components/select.vue'
import EInput from '../components/Input.vue'
import EDialog from '../components/dialog.vue'
import EIcon from '../components/Icon.vue'

export default {
  name: 'layout',
  created() {
    let query = this.GetRequest()
    let currenturl = window.location.href
    let hash = currenturl.split('?')[1]
    if (hash && query.url !== undefined) {
      if (query.os) {
        this.params.os = query.os === '0' ? '2' : query.os
      }
      if (query.country) {
        this.params.country = query.country
      }
      if (query.zone) {
        if (query.zone === '2') {
          this.carrier = setting.carriers
        }
        this.params.zone = query.zone
      }
      if (query.carrier) {
        this.params.carrier = query.carrier
      }
      this.params.url = query.url
      if (!this.$parent.isOFFERSYOUMI && !this.$parent.isYOUMIEN) {
        this.search()
      }
    }

    for (let i = 0; i < this.os.length; i++) {
      this.os[i].show = true
    }
    for (let i = 0; i < this.country.length; i++) {
      this.country[i].show = true
    }

    if (this.$parent.isYOUMIEN) {
      this.params.source = 1
      let url = this.$parent.baseurl
      this.http.get(
        url + '/api/login_info',
        {},
        data => {
          if (data.user_id) {
            this.params.uid = data.user_id
          }
          this.getCheckTimes()
        },
        e => {},
        { withCredentials: true }
      )
    } else if (this.$parent.isOFFERSYOUMI) {
      this.params.source = 0
      this.getCheckTimes()
    } else {
      this.params.source = 2
    }
  },
  computed: {
    zone() {
      return setting.zones.filter(item => {
        if (this.$parent.isOFFERSYOUMI || this.$parent.isYOUMIEN) {
          return item.id !== '1'
        } else {
          return item
        }
      })
    },
  },
  data() {
    return {
      os: setting.os,
      country: setting.countries,
      carrier: setting.default_carriers,
      timer: null,
      LOADING: false,
      http: new Http(),
      land_page: false,
      user_agent: '',
      res_header: '',
      result: [],
      // 总耗时
      delta: 0,
      error: false,
      error_message: '',
      params: {
        os: '2',
        country: 'US',
        url: '',
        zone: '0',
        carrier: '',
        source: '',
      },

      check_times: '',

      hideSuccess: true,
    }
  },
  methods: {
    GetRequest() {
      let url = location.search
      let q = {}
      if (url.indexOf('?') !== -1) {
        let str = url.substr(1)
        let strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
          q[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
        }
      }
      return q
    },
    location: function() {
      return window.location.href
    },
    selectCountry(v) {
      this.params.country = v
      // 如果是mobile，允许设置carrier，每个国家都有其carrier
      if (this.params.zone === '2') {
        this.carrier = setting.carriers
      } else {
        this.carrier = setting.default_carriers
      }
      this.params.carrier = ''
    },
    selectOS(v) {
      this.params.os = v
    },
    selectZone(v) {
      this.params.zone = v
      // 如果是mobile，允许设置carrier
      if (v === '2') {
        this.carrier = setting.carriers
      } else {
        this.carrier = setting.default_carriers
      }
      this.params.carrier = ''
    },
    selectCarrier(v) {
      this.params.carrier = v
    },
    search() {
      this.land_page = false
      this.res_header = ''
      this.user_agent = ''
      this.delta = 0
      this.content = ''
      this.LOADING = true

      let currenturl = window.location.href
      let newUrl = currenturl.split('?')[0]

      history.pushState('', '', newUrl + this.buildUrl(this.params.url))
      if (this.xhr) {
        this.xhr.abort(this.params.url)
      }
      clearTimeout(this.timer)
      let url = 'api/adtrack/track/'
      this.timer = setTimeout(() => {
        this.xhr = this.http.get(
          this.prefixUrl(url),
          this.params,
          data => {
            this.LOADING = false
            this.error = false
            this.error_message = ''
            this.result = data.urls
            this.land_page = data.land_page || false
            this.delta = data.delta
            this.user_agent = data.user_agent
            this.res_header = data.header
            if (this.$parent.isOFFERSYOUMI || this.$parent.isYOUMIEN) {
              this.getCheckTimes()
            }
          },
          e => {
            this.error = true
            this.error_message = e.msg
            this.result = []
            this.LOADING = false
            if (this.$parent.isOFFERSYOUMI || this.$parent.isYOUMIEN) {
              this.getCheckTimes()
            }
            if (e.urls) {
              this.result = e.urls
            }
            this.land_page = e.land_page || false
          }
        )
      }, 500)
    },
    localview(url) {
      let req_url = 'api/adtrack/proxy'
      let win = window.open(this.prefixUrl(req_url) + this.buildUrl(url), '_blank')
      win.focus()
    },
    clickOutside() {
      this.$refs.os.hideList()
      this.$refs.country.hideList()
      this.$refs.zone.hideList()
    },

    showDetail(res) {
      res.header = this.res_header
      res.user_agent = this.user_agent
      this.$refs.detailDialog.show(res)
    },
    screenshot() {
      if (this.result.length === 0) {
        return
      }
      let lastJump = this.result[this.result.length - 1]
      let url = encodeURIComponent(lastJump.url)
      let req_url = 'api/adtrack/screenshot?url=' + url
      req_url = this.prefixUrl(req_url, '&source=1')
      let win = window.open(req_url, '_blank')
      win.focus()
    },
    getCheckTimes() {
      let url = 'api/adtrack/track-times/'
      this.http.get(
        this.prefixUrl(url),
        this.params,
        data => {
          this.check_times = data.t
        },
        e => {}
      )
    },
    buildUrl(url) {
      let query = `?os=${this.params.os}&country=${this.params.country}&zone=${this.params.zone}`
      query = this.$parent.isYOUMIEN ? query + '&source=1' : query
      query = this.params.carrier.length > 0 ? query + `&carrier=${this.params.carrier}` : query
      return query + '&url=' + encodeURIComponent(url)
    },
    copySuccess() {
      this.hideSuccess = false
      setTimeout(() => {
        this.hideSuccess = true
      }, 1500)
    },
    prefixUrl(url, rest) {
      if (this.$parent.isYOUMIEN) {
        url = this.$parent.prefix + url
        if (rest) {
          url += rest
        }
      }
      return url
    },
  },
  components: {
    loading,
    ESelect,
    EInput,
    EDialog,
    EIcon,
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.wrapper {
  text-align: center;
}

.wrapper .row {
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  align-items: center;
}

.wrapper .pl {
  padding-left: 12px;
}

.pr {
  padding-right: 12px;
}

.wrapper .select {
  margin-top: 4px;
}

.wrapper .search-panel {
  margin: 0 auto;
  width: 100%;
  margin-bottom: 30px;
  padding: 10px 0;
}

.wrapper .list-item {
  width: 100%;
  margin-bottom: 26px;
  text-align: left;
}

.wrapper .submit {
  color: #fff;
  font-size: 14px;
  min-width: 66px;
  padding: 0 14px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  flex-wrap: nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-weight: 400;
  outline: 0;
  border: none;
  cursor: pointer;
  width: 128px;
  height: 32px;
  background: #0080cc;
  border-radius: 16px;
}

.wrapper .error_tip {
  font-size: 18px;
  line-height: 24px;
}

.wrapper .gutter {
  margin-bottom: 10px;
  text-align: left;
}

.wrapper .row {
  margin-bottom: 24px;
}

.wrapper .row.gutter .col {
  width: 50%;
}

.wrapper .status {
  margin-right: 10px;
  padding: 0 14px;
  height: 32px;
  text-align: center;
  border: 1px solid #e1e4eb;
  border-radius: 16px;
  color: #909399;
}

.youmi-en .search-panel {
  margin-top: 32px;
  width: 60%;
}

.youmi-en button.submit {
  width: 240px;
  height: 56px;
  font-size: 22px;
  background: linear-gradient(-90deg, #ff8a6b 0%, #f5409a 100%);
  box-shadow: 0px 3px 8px 0px rgba(3, 0, 0, 0);
  border-radius: 28px;
  border: none;
}

.ym-label {
  color: #909399;
  font-size: 14px;
}

.result-panel {
  min-height: 400px;
}

.youmi-en .result-panel {
  min-height: 800px;
  background: linear-gradient(0deg, #fff 0%, #eff0ff 100%);
}

.youmi-en .result {
  margin: 0 auto;
  width: 70%;
}

.youmi-en .result-panel {
  padding-top: 56px;
}

.wrapper .yicon-view {
  color: #d1d1ea;
  font-size: 16px;
}

.wrapper .i-excalmatory-fill {
  margin-right: 18px;
  color: #d1d1ea;
  font-size: 32px;
}

.wrapper .yicon-view:hover {
  color: #f54299;
}

.result-title {
  margin: 16px 0 0 0;
  font-size: 16px;
  color: #6b6d71;
  text-align: left;
  font-weight: 400;
}
.youmi-en .result-title {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  line-height: 48px;
  color: #676565;
}
.pointer {
  cursor: pointer;
}

.result-footer {
  margin-top: 60px;
}

.youmi-offers .result-footer {
  margin-top: 24px;
}

.footer-copy {
  margin-top: 16px;
}

.icon.gradient-icon {
  font-size: 26px;
}

.youmi-offers .icon.gradient-icon {
  color: #0080cc;
  vertical-align: sub;
}

.error {
  margin-top: 70px;
  margin-bottom: 30px;
}

.youmi-en .error {
  margin-top: 0;
}
.youmi-en .icon.gradient-icon {
  vertical-align: sub;
  background-image: -webkit-linear-gradient(bottom, #e10077, #ff8d60);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.circle {
  position: relative;
  margin-left: 10px;
  margin-right: 20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #fff;
}

.youmi-en .green {
  color: #33cc8c;
}
.green {
  color: #84d245;
}

.youmi-en .background-green {
  background: #33cc8c;
}

.background-green {
  background: #84d245;
}

.circle.has-dashed-line:after {
  position: absolute;
  top: 20px;
  height: 40px;
  left: 48%;
  content: '';
  z-index: 0;
  width: 0;
  border-left: dashed #e1e4eb 1px;
}

.red {
  color: #ff6699;
}

.background-red {
  background: #ff6699;
}

.inline-block {
  display: inline-block;
}
.item-center {
  flex-grow: 1;
}
.item-left {
  display: flex;
  order: -1;
  flex: 0 1 100px;
  align-items: center;
  justify-content: space-between;
}

.item-left-short {
  flex: 0 1 80px;
}

.item-right {
  flex: 0 1 40px;
  text-align: right;
}

.item-index {
  margin-right: 10px;
  color: #606266;
  font-size: 24px;
  font-weight: bold;
}

.youmi-en .result-list {
  padding-top: 60px;
}

.youmi-offers .result-list {
  padding-top: 20px;
}

.hr {
  height: 2px;
  background-color: rgba(246, 248, 251, 1);
  border: none;
}

.info-rest {
  margin-top: 16px;
  font-size: 16px;
}

.youmi-en .info-rest em {
  color: #fb6880;
}
.youmi-offers .info-rest em {
  color: #0080cc;
}

.circle .yicon-down2,
.circle .yicon-wrong {
  text-align: left;
  font-size: 20px;
  line-height: 20px;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ms {
  width: 44px;
}
</style>
